import React from "react";
import Text from "components/common/Text";
import Box from "components/common/Box";
import { useAuthFieldStyles } from "./authFieldStyles";

const AuthPhoneField = ({
  label = "Phone Number",
  value,
  onChange,
  error,
  placeholder = "00000 00000",
  onKeyUp,
  disabled = false,
  sx = {},
}) => {
  const classes = useAuthFieldStyles();

  const handleChange = (e) => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    onChange(digits);
  };

  const validateCharCode = (e) => {
    if (e.charCode === 46) {
      e.preventDefault();
    }
  };

  return (
    <Box sx={{ width: 1, mb: "18px", ...sx }}>
      {label ? (
        <Text
          sx={{
            fontSize: "14px",
            fontWeight: 500,
            color: "#000",
            mb: "10px",
            lineHeight: 1,
            fontFamily: "'DM Sans', sans-serif",
          }}
        >
          {label}
        </Text>
      ) : null}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          height: "52px",
          border: "1px solid rgba(204, 209, 217, 0.2)",
          borderRadius: "8px",
          px: "20px",
          background: "rgba(255, 255, 255, 0.8)",
          backdropFilter: "blur(5px)",
          boxShadow: "0px 0px 26px 0px rgba(0, 0, 0, 0.06)",
          boxSizing: "border-box",
          opacity: disabled ? 0.7 : 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "6px",
            flexShrink: 0,
          }}
        >
          <Box
            component="img"
            src="/images/signup/india-flag.png"
            alt="India"
            sx={{
              width: 19,
              height: 12,
              display: "block",
              objectFit: "cover",
            }}
          />
          <Box
            component="img"
            src="/images/signup/chevron-down.svg"
            alt=""
            aria-hidden
            sx={{ width: 12, height: 12, display: "block", opacity: 0.7 }}
          />
          <Text
            sx={{
              fontSize: "12px",
              color: "#99a1ab",
              lineHeight: 1,
              whiteSpace: "nowrap",
              fontFamily: "'DM Sans', sans-serif",
            }}
          >
            +91
          </Text>
        </Box>
        <input
          className={classes.phoneInput}
          type="tel"
          inputMode="numeric"
          placeholder={placeholder}
          value={value}
          onKeyPress={validateCharCode}
          onChange={handleChange}
          onKeyUp={onKeyUp}
          disabled={disabled}
          maxLength={10}
        />
      </Box>
      {error ? (
        <Text sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>{error}</Text>
      ) : null}
    </Box>
  );
};

export default AuthPhoneField;
